import * as React from 'react';
import { enableRipple } from '@syncfusion/ej2-base';
import { loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import {
  DialogComponent,
  ButtonPropsModel,
  AnimationSettingsModel,
} from '@syncfusion/ej2-react-popups';
import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import { TextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { GetBackendUrlForGlobalFunctions } from '../../App';
import {
  TreeViewComponent,
  ContextMenuComponent,
} from '@syncfusion/ej2-react-navigations';
import {
  getAssignments,
  getAssignmentsDetails,
  setterTeamAndTradeToAssignment,
} from '../../services/assignments/assignmentService';
import './style.css';
import { DropDownButtonComponent, ItemModel } from '@syncfusion/ej2-react-splitbuttons';
import {
  IoAddSharp,
  IoCheckmarkDoneOutline,
  IoRefresh,
  IoTrashOutline,
} from 'react-icons/io5';
import { GoPencil } from 'react-icons/go';
import { toast } from 'react-toastify';
import Scheduler from '../../components/GlobalScheduler';
import { ThemeContext } from '../../context/theme.context';
import { UploaderComponent } from '@syncfusion/ej2-react-inputs';
import defaultImage from '../../assets/images/DefaultImage.png';
import {
  addAssignment,
  editAssignment,
  deleteAssignment,
} from '../../services/assignments/assignmentService';
import TeamAndTradeSetter from '../../utils/TeamAndTradeSetter';
import GenerateCapacity from '../../utils/GenerateCapacity';
import { searchNodes } from '../../utils/GetFilterItems';
import {
  setAssignments,
  setDefaultTeams,
  setRefreshAssignmentComponent,
  setRefreshTeamComponent,
  setRefreshTradeComponent,
  setStoreAssign,
  setTrades,
} from '../../redux/search.slice';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { stringToArray } from '../../utils/Methods/methods';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getTeams } from '../../services/tradeperson/team';
import { getTrades } from '../../services/tradeperson/trades';
import { all_information } from '../../App';
import {
  IoArrowUp,
  IoArrowDown,
  IoSwapVerticalOutline,
  IoCloseOutline,
} from 'react-icons/io5';
enableRipple(true);
interface IState {
  AssignmentData: any;
  fields: any;
  hideDialog: boolean;
  hideDialogAssignAdd: boolean;
  hideDialogAssignEdit: boolean;
  hideDialogAssignDelete: boolean;
  tradeTeamSetVisible: boolean;
  disabledAssignModal: boolean;
  selectedAssignments: Array<any>;
  isNoteMode: boolean;
  teamData: any;
  tradeData: any;
  teamId: any;
  tradeId: any;
  dropdownTeamSelectionForEdit: any;
  dropdownTradeSelectionForEdit: any;
  dropdownTeamSelection: any;
  dropdownTradeSelection: any;
  sortType: string;
  sortField: 'name' | 'surname' | null;
  sortDir: 'asc' | 'desc' | null;
  baseAssignmentData: any[];
}
interface TeamInfo {
  team_id: number;
  trade_id: number;
}
interface IProps {
  setTrades: (data: number[]) => void;
  setRefreshTradeComponent: (data: boolean) => void;
  setRefreshTeamComponent: (data: boolean) => void;
  defaultTeams: number[];
  refreshAssignmentComponent: boolean;
  setRefreshAssignmentComponent: (data: boolean) => void;
  setAssignments: (data: number[]) => void;
  setStoreAssign: (data: string[]) => void;
  defaultAssignments: number[];
  defaultTrades: number[];
  storeAssign: string[];
}
class Assignments extends React.Component<IProps, IState> {
  public treeObj: TreeViewComponent;
  public menuObj: any;
  public index = 1;
  public menuItems: any;
  private buttonsAssignmentsDelete: ButtonPropsModel[];
  private animationSettings: AnimationSettingsModel;
  public dialogInstance: any;
  public buttonEle: any;
  public selectedName: string;
  private isChecked: boolean = true;
  checkedNodes: any;
  private assignmentId: string;
  public maskObj: TextBoxComponent;
  public globalAssignmentResponseData: any = [];
  static contextType = ThemeContext;
  public tempList: any[] = [];
  context!: React.ContextType<typeof ThemeContext>;
  private addAssignName: string = '';
  private addAssignLastname: string = '';
  private editAssignName: string = '';
  private assignPersonID: string = '';
  private editAssignLastname: string = '';
  private assignmentIdEdit: number = -1;
  private assignmentIdDelete: number = -1;
  private assignmentIdsDelete: number[] = [];
  private sortMenuItems: ItemModel[] = [
    { text: 'First Name (A-Z)', id: 'name_asc' },
    { text: 'First Name (Z-A)', id: 'name_desc' },
    { text: 'Last Name (A-Z)', id: 'surname_asc' },
    { text: 'Last Name (Z-A)', id: 'surname_desc' },
  ];
  constructor(props: IProps) {
    super(props);
    this.nodeChecked = this.nodeChecked.bind(this);
    this.setStoreAssignHandle = this.setStoreAssignHandle.bind(this);
    this.treeObj = new TreeViewComponent(props);
    this.menuObj = new ContextMenuComponent(props);
    this.dialogInstance = new DialogComponent(props);
    this.maskObj = new TextBoxComponent(props);
    this.selectedName = '';
    this.assignmentId = '';
    this.buttonsAssignmentsDelete = [
      {
        click: () => {
          this.deleteAssignElement();
        },
        buttonModel: {
          content: 'Accept',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogAssignDelete: false });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.menuItems = [
      { text: 'Assign Shift Element' },
      { text: 'Assign Note' },
      { text: 'Set Teams Trades' },
    ];
    this.state = {
      AssignmentData: [],
      fields: {
        dataSource: [],
        id: '',
        text: '',
        hasChildren: '',
        selected: '',
      },
      hideDialog: false,
      hideDialogAssignAdd: false,
      tradeTeamSetVisible: false,
      hideDialogAssignDelete: false,
      hideDialogAssignEdit: false,
      disabledAssignModal: false,
      selectedAssignments: [],
      isNoteMode: false,
      teamData: [],
      tradeData: [],
      teamId: '',
      tradeId: '',
      dropdownTeamSelectionForEdit: '',
      dropdownTradeSelectionForEdit: '',
      dropdownTeamSelection: '',
      dropdownTradeSelection: '',
      sortType: '',
      sortField: null,
      sortDir: null,
      baseAssignmentData: [],
    };
  }
  saveAssignmentWithTeamsAndTrades = async (assignment: any, obj: TeamInfo) => {
    if (!obj.team_id || !obj.trade_id || obj.team_id === 0 || obj.trade_id === 0) {
      loadingShow(false);
      return; 
    }
    var teamInfos: [] = (await getTeams()).data;
    var tradeInfos: [] = (await getTrades()).data;
    teamInfos.map(async (eachinfo: any) => {
      if (eachinfo.team_id == obj.team_id) {
        assignment.team_code = eachinfo.team_code;
        assignment.teams = [
          {
            assignment_id: assignment.assignment_id,
            team_code: eachinfo.team_code,
            team_id: assignment.team_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id,
            creation_date: new Date(),
            created_by: all_information.user_id,
          },
        ];
      }
    });
    tradeInfos.map((eachtrade: { trade_id: number; trade_code: string }) => {
      if (eachtrade.trade_id == obj.trade_id) {
        assignment.trades = [
          {
            assignment_id: assignment.assignment_id,
            trade_code: eachtrade.trade_code,
            trade_id: obj.trade_id,
            app: 'UWORK',
            user_id: all_information.user_id,
            organization_id: all_information.company_id?.toString(),
            creation_date: new Date(),
            created_by: all_information.user_id,
          },
        ];
      }
    });
    if (assignment.team_id !== '' || assignment.trade_id !== '') {
      setterTeamAndTradeToAssignment(assignment)
        .then((_response) => {
          loadingShow(false);
          this.setState({ teamId: '' });
          this.setState({ tradeId: '' });
        })
        .catch((e) => {
          loadingShow(false);
          Message.error('Error occured');
          //(e);
        });
    }
  };

  async addAssignElement() {
    this.setState({ disabledAssignModal: true });
    if (this.addAssignName === '') {
      this.setState({ disabledAssignModal: false });
      Message.error("Name mustn't be empty");
      return;
    }
    if (this.addAssignLastname === '') {
      this.setState({ disabledAssignModal: false });
      Message.error("Lastname mustn't be empty");
      return;
    }

    var full_name =
      this.addAssignName.trim() + ' ' + this.addAssignLastname.trim();
    const fullNameControl = full_name.replace(' ', '');
    const nameIfExists = this.state.AssignmentData.find(
      (x: any) =>
        x.alias_name.toLowerCase().replace(' ', '') ===
        fullNameControl.toLowerCase()
    );
    if (nameIfExists !== null && nameIfExists !== undefined) {
      this.setState({ disabledAssignModal: false });
      Message.error('The table of the same name already exists');
      return false;
    }
    loadingShow(true);
    let obj = {
      shift: '',
      app: 'UWORK',
      created_by: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      creation_date: new Date(),
      description: '',
      first_name: this.addAssignName,
      last_name: this.addAssignLastname,
      full_name: full_name,
      alias_name: full_name,
      image_url: '',
      is_mastered: false,
      team_id: this.state.teamId,
      trade_id: this.state.tradeId,
      erp_assignment_id: this.assignPersonID,
    };
    await addAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Added successfully...');

        this.setState({
          hideDialogAssignAdd: false,
          disabledAssignModal: false,
        });
        //this.context.setDataChange(true);
        this.getAssignments();
        this.saveAssignmentWithTeamsAndTrades(result.data, {
          team_id: this.state.teamId,
          trade_id: this.state.tradeId,
        });

        this.props.defaultTeams.map((eachDefaulTeamId) => {
          if (this.state.teamId === eachDefaulTeamId) {
            var tempListForAssignment = [...this.props.defaultAssignments];
            tempListForAssignment.push(result.data.assignment_id);
            this.props.setAssignments(tempListForAssignment);
            var tempListForTrade = [...this.props.defaultTrades];
            tempListForTrade.push(result.data.trade_id);
            this.props.setTrades(tempListForTrade);
            setTimeout(() => {
              this.props.setRefreshTeamComponent(true);
              this.props.setRefreshTradeComponent(true);
            }, 1000);
          }
        });
      })
      .catch((err) => {
        loadingShow(false);
        console.log('err', err);
        Message.error('Add failed!!!');
        this.setState({ disabledAssignModal: false });
      });
  }
  editAssignElement() {
    loadingShow(true);
    this.setState({ disabledAssignModal: true });
    var assignmentId = this.assignmentIdEdit;
    if (this.editAssignName === '') {
      this.setState({ disabledAssignModal: false });
      Message.error('Name cannot be empty');
      return;
    }
    if (this.editAssignLastname === '') {
      this.setState({ disabledAssignModal: false });
      Message.error('Lastname cannot be empty');
      return;
    }

    var full_name = this.editAssignName + ' ' + this.editAssignLastname;
    var first_name = this.addAssignName;
    var last_name = this.addAssignLastname;
    let obj = {
      description: '',
      first_name: this.editAssignName,
      last_name: this.editAssignLastname,
      full_name: full_name,
      alias_name: full_name,
      image_url: '',
      is_mastered: false,
      assignment_id: Number(assignmentId),
      team_id: this.state.teamId,
      trade_id: this.state.tradeId,
      erp_assignment_id: this.assignPersonID,
    };

    editAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Edited successfully...');
        this.getAssignments();
        this.setState({
          hideDialogAssignEdit: false,
          disabledAssignModal: false,
        });
        this.saveAssignmentWithTeamsAndTrades(result.data, {
          team_id: this.state.teamId,
          trade_id: this.state.tradeId,
        });
        //this.context.setDataChange(true);
        //this.setTradeTeamAffected()
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Edit failed!!!');
        this.setState({ disabledAssignModal: false });
      });
  }
  deleteAssignElement() {
    // let obj = {
    //   assignment_id: Number(this.assignmentIdDelete),
    // };
    let obj = this.assignmentIdsDelete;

    deleteAssignment(obj)
      .then((result) => {
        loadingShow(false);
        Message.success('Deleted  successfully...');
        this.getAssignments();
        this.props.setRefreshTeamComponent(true);
        this.props.setRefreshTradeComponent(true);
        //this.context.setDataChange(true);
        this.assignmentIdsDelete = [];
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Operation failed!!!');
      });
    this.setState({ hideDialogAssignDelete: false });
  }
  public dlgButtonClick(): void {
    this.setState({ hideDialog: false });
  }
  private setTeamTradeDialog(value: boolean): void {
    this.setState({ tradeTeamSetVisible: value });
  }
  public dlgButtonClickAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: false });
  }
  private dialogCloseAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: false });
  }
  private dialogOpenAssignCrud(): void {
    this.setState({ hideDialogAssignAdd: true });
  }
  private ORG_NODE_BASE = 900000000;

  private filterBySelectedOrgs = (list: any[]): any[] => {
  let selectedIds: string[] = [];
  try {
    const raw = localStorage.getItem('selectedOrgIds');
    selectedIds = raw ? JSON.parse(raw).map(String) : [];
  } catch {
    selectedIds = [];
  }
  if (!list || selectedIds.length === 0) return list;

  return list.filter(
    (n: any) =>
      n.organization_id != null &&
      selectedIds.includes(String(n.organization_id))
  );
};

private withOrgGroups = (list: any[]): any[] => {
  if (!list || list.length === 0) return list;
  const orgs = new Map<string, any>();

  const result = list.map((n: any) => {
    const key = String(n.organization_id ?? 'none');
    if (!orgs.has(key)) {
      const orgName = n.organization_code ?? 'No Organization';
      orgs.set(key, {
        assignment_id: this.ORG_NODE_BASE + (Number(n.organization_id) || 0),
        pid: null,
        full_name: orgName,
        alias_name: orgName,
        hasChild: true,
        expanded: true,
      });
    }
    return { ...n, pid: orgs.get(key).assignment_id };
  });

  const orgNodes = Array.from(orgs.values()).sort((a, b) =>
    String(a.full_name).localeCompare(String(b.full_name))
  );
  return [...orgNodes, ...result];
};

private buildFields = (data: any[]) => ({
  dataSource: this.withOrgGroups(data),
  id: 'assignment_id',
  parentID: 'pid',
  text: 'full_name',
  hasChildren: 'hasChild',
  expanded: 'expanded',
  selected: 'isSelected',
});

private isOrgNode = (id: any) => Number(id) >= this.ORG_NODE_BASE;

private getCheckedAssignmentIds = (): string[] =>
  (this.treeObj.getAllCheckedNodes() as string[]).filter(
    (id) => !this.isOrgNode(id)
  );

private onDrawNode = (args: any) => {
  const id =
    args.node?.getAttribute('data-uid') ??
    args.nodeData?.assignment_id ??
    args.nodeData?.id;

  if (!this.isOrgNode(id)) return;

  args.node.classList.add('org-node');
};
  componentDidMount() {
    getTeams().then((result) => {
      result.data.unshift({
        team_code: '',
        team_id: -1,
      });
      this.setState({ teamData: result.data });
    });
    getTrades().then((result) => {
      result.data.unshift({
        trade_code: '',
        trade_id: -1,
      });
      this.setState({ tradeData: result.data });
    });
    this.getAssignments();
  }
  // getAssignment() {
  //   getAssignments().then((result) => {
  //     this.setState({ AssignmentData: result.data });
  //   });

  //   // $('#maskedTextBoxSearch').val('Search...');
  // }
  async componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): Promise<void> {
    if (prevProps.defaultAssignments !== this.props.defaultAssignments) {
      var tempList: any[] = [];

      if (this.props.defaultTeams?.length > 0) {
        this.props.defaultAssignments.map(
          (eachAssignmentid: number, index: number) => {
            this.globalAssignmentResponseData.map(
              (eachData: { assignment_id: number }) => {
                if (eachData.assignment_id === eachAssignmentid) {
                  tempList.push(eachData);
                }
              }
            );
          }
        );
      } else {
        tempList = this.globalAssignmentResponseData;
      }
      const sortedList = this.getCurrentSortedData();
      this.setState({
        AssignmentData: sortedList,
        fields: this.buildFields(sortedList),
      });
    }
    if (this.context.isDataChangeTeam) {
      this.context.setDataChangeTeam(false);
    }
    if (
      prevProps.refreshAssignmentComponent !==
      this.props.refreshAssignmentComponent
    ) {
      this.checkedNodes = [];
      this.props.setStoreAssign([]);
      this.treeObj.uncheckAll();
      await this.getAssignments();
      this.props.setRefreshAssignmentComponent(false);
    }
  }
  private async getAssignments() {
    await getAssignments().then((result) => {
      this.globalAssignmentResponseData = this.filterBySelectedOrgs(result.data);
      const sortedList = this.getCurrentSortedData();
      this.setState({
        AssignmentData: sortedList,
        fields: this.buildFields(sortedList),
      });
    });
  }
  nodeclicked(args: any) {
    const assignmentId = args.node.getAttribute('data-uid');
    if (this.isOrgNode(assignmentId)) {
      this.assignmentId = '';
      this.selectedName = '';
      return;
    }
    this.assignmentId = assignmentId;
    this.selectedName = this.filterAssignmentName(this.state.AssignmentData, assignmentId);
  }
  menuclick = async (args: any) => {
    if (args.item !== undefined) {
      if (
        args.item.text === 'Assign Shift Element' ||
        args.item.text === 'Assign Note'
      ) {
        if (args.item.text === 'Assign Shift Element') {
          let selectedOrgs: any[] = [];
          try {
            selectedOrgs = JSON.parse(localStorage.getItem('selectedOrgIds') || '[]');
          } catch {}

          if (selectedOrgs.length === 0) {
            Message.warning('An organization must be selected to create capacity.');
            return;
          }

          if (selectedOrgs.length > 1) {
            Message.warning('Creating capacity is not allowed when multiple organizations are selected.');
            return;
          }
        }
        loadingShow(true, 'Preparing...');
        const checked = this.getCheckedAssignmentIds();
        if (checked.length > 0) {
          this.assignmentId = checked.toString();
        }
        if (args.item.text === 'Assign Note') {
          this.setState({ isNoteMode: true });
        } else {
          this.setState({ isNoteMode: false });
        }
        getAssignmentsDetails(this.assignmentId)
          .then((response) => {
            loadingShow(false, 'Preparing...');
            this.setState({
              selectedAssignments: response.data,
              hideDialog: true,
            });
          })
          .catch((e: any) => {
            //(e);
            toast.error('Error occured.Please try again later');
            loadingShow(false, 'Preparing...');
          });
      } else if (args.item.text === 'Set Teams Trades') {
        loadingShow(true, 'Preparing...');
        this.setState({
          tradeTeamSetVisible: true,
        });
      }
    }
  };

  setStoreAssignHandle(team: string[]) {
    this.props.setStoreAssign(team);
  }

  nodeChecked(args: any) {
  const clickedId = Number(args.data[0].id);
  const ids: string[] = this.isOrgNode(clickedId)
    ? this.state.fields.dataSource
        .filter((d: any) => d.pid === clickedId)
        .map((d: any) => d.assignment_id.toString())
    : [args.data[0].id];

    if (args.action === 'check') {
      ids.forEach((id) => {
        if (!this.tempList.includes(id)) this.tempList = [...this.tempList, id];
      });
    } else {
      this.tempList = this.tempList.filter((x) => !ids.includes(x));
    }
    this.setStoreAssignHandle(this.tempList);
  }
  changeDataSource(data: any) {
    this.setState({ fields: this.buildFields(data) });
  }
  searchNodes(args: any) {
    searchNodes(
      args.value,
      this.state.AssignmentData,
      this.changeDataSource.bind(this),
      'alias_name',
      'assignment_id'
    );
  }
  getFilterItems(fList: any, list: any): any {
    let nodes = [];
    nodes.push(fList['assignment_id']);
    let query2 = new Query().where(
      'assignment_id',
      'equal',
      fList['pid'],
      false
    );
    let fList1 = new DataManager(list).executeLocal(query2);
    if (fList1.length !== 0) {
      let pNode: any = this.getFilterItems(fList1[0], list);
      for (let i = 0; i < pNode.length; i++) {
        if (nodes.indexOf(pNode[i]) === -1 && pNode[i] != null)
          nodes.push(pNode[i]);
      }
      return nodes;
    }
    return nodes;
  }
  //#region ForFilter
  filterAssignmentName(input: any, id: any) {
    let assignmentName = input.filter((item: any) => {
      return item.assignment_id == id;
    });
    return assignmentName[0]['full_name'];
  }
  //#endregion
  //#region Assingment ve Exception
  //#endregion
  AddAssignOpenModal = () => {
    this.addAssignName = '';
    this.addAssignLastname = '';
    this.assignPersonID = '';
    this.dialogOpenAssignCrud();
  };
  EditAssignOpenModal = () => {
    const checked = this.getCheckedAssignmentIds();
    //getAllCheckedNodes
    if (checked.length > 0) {
      if (checked.length === 1) {
        this.assignmentIdEdit = Number(checked[0]);
        loadingShow(true, 'Preparing...');
        getAssignmentsDetails(this.assignmentIdEdit)
          .then((e) => {
            this.editAssignLastname = e.data[0].last_name;
            this.editAssignName = e.data[0].first_name;
            this.assignPersonID = e.data[0].erp_assignment_id;
            this.setState({ tradeId: e.data[0].trade_id });
            this.setState({ teamId: e.data[0].team_id });

            loadingShow(false);
            this.setState({ hideDialogAssignEdit: true });
          })
          .catch((e) => {
            Message.error('Error occured');
            loadingShow(false);
            //(e);
          });
      } else {
        Message.error('No allowed editted on multi selection mode');
      }
    } else {
      Message.warning('No selected any tradeperson');
    }
  };
  DeleteAssignOpenModal = () => {
    const checked = this.getCheckedAssignmentIds();
    if (checked.length > 0) {
      this.assignmentIdsDelete = checked.map((id) => Number(id));
      this.setState({ hideDialogAssignDelete: true });
    } else {
      Message.warning('No selected any tradeperson to delete');
    }
  };
  //#region SetTeamTrades
  //#endregion

  //#region template
  //#endregion
  setChangeData = (value: boolean) => {
    this.context.setDataChange(value);
  };
  getAssignImage(value: any) {
    // var name = value;
    // var image =
    //   GetBackendUrlForGlobalFunctions()+'static/media/people/' + name;

    // if (name === '') image = defaultImage;
    return defaultImage;
  }
  TreeAssignRenderTemplate = (val: any) => {
  if (this.isOrgNode(val.assignment_id)) {
    return <div className='ename'>{val.alias_name}</div>;
  }
    return (
      <div className='render-assign-tree'>
        <img className='eimage' src={this.getAssignImage(val.IMG_URL)}></img>
        <div className='ename'>{val.alias_name}</div>
      </div>
    );
  };
  setTradeTeamAffected = () => {
    this.context.setDataChangeTrade(true);
    this.context.setDataChangeTeam(true);
    //this.context.setDataChange(true);
  };
  applySort(field: 'name' | 'surname', dir: 'asc' | 'desc', source: any[]) {
    const key = field === 'surname' ? 'last_name' : 'first_name';
    return [...source].sort((a: any, b: any) => {
      const result = (a[key] || '')
        .toLowerCase()
        .localeCompare((b[key] || '').toLowerCase());
      return dir === 'desc' ? -result : result;
    });
  }

  getCurrentSortedData(): any[] {
    let sourceList = this.globalAssignmentResponseData;

    if (this.props.defaultTeams?.length > 0) {
      sourceList = [];
      this.props.defaultAssignments.forEach((eachAssignmentid: number) => {
        this.globalAssignmentResponseData.forEach((eachData: any) => {
          if (eachData.assignment_id === eachAssignmentid) {
            sourceList.push(eachData);
          }
        });
      });
    }

    if (this.state.sortField) {
      return this.applySort(
        this.state.sortField,
        this.state.sortDir as 'asc' | 'desc',
        sourceList
      );
    }
    return sourceList;
  }

  onSortMenuSelect = (args: any) => {
    const id: string = args.item.id;
    const [field, dir] = id.split('_') as ['name' | 'surname', 'asc' | 'desc'];
  
    this.setState({ sortField: field, sortDir: dir }, () => {
      const result = this.getCurrentSortedData();
      this.setState({ AssignmentData: result });
      this.changeDataSource(result);
    });
  };

  clearSort = () => {
    this.setState({ sortField: null, sortDir: null }, () => {
      const result = this.getCurrentSortedData();
      this.setState({ AssignmentData: result });
      this.changeDataSource(result);
    });
  };

  getSortLabel(): string {
    if (!this.state.sortField) return '';
    const field = this.state.sortField === 'name' ? 'First Name' : 'Last Name';
    const dir = this.state.sortDir === 'asc' ? 'A-Z' : 'Z-A';
    return `${field} (${dir})`;
  }

  public sortDropDownRef: any;
  render() {
    return (
      <div className='tradesperson-panel'>
        <div className='assignments-header-crud'>
          <h5 className='assignments-baslik'>TRADESPERSON</h5>
          <div className='assignment-crud'>
            <div className='add-assignment'>
              <IoAddSharp onClick={this.AddAssignOpenModal} size={17} />
            </div>
            <div className='edit-assignment'>
              <GoPencil onClick={this.EditAssignOpenModal} size={17} />
            </div>
            <div className='delete-assignment'>
              <IoTrashOutline onClick={this.DeleteAssignOpenModal} size={17} />
            </div>
            <div className='refresh-assignment'>
              <IoRefresh
                onClick={async () => {
                  toast.info('Assignments are refreshing...');
                  this.checkedNodes = [];
                  this.props.setStoreAssign([]);
                  this.treeObj.uncheckAll();

                  await this.getAssignments();
                  toast.success('Assignments refreshed successfully...');
                  //closed because after click refresh button this one send a get capacity request
                  //this.context.setDataChangeAssignment(false);
                }}
                size={17}
              />
            </div>
            <div className='uncheck-assignment'>
              <IoCheckmarkDoneOutline
                onClick={() => {
                  this.checkedNodes = [];
                  // Scheduler.StoreTrades = [];
                  this.treeObj.uncheckAll();
                }}
                size={17}
              />
            </div>
          </div>
        </div>
        <div className='searchAssign'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              height: 30,
            }}
          >
        <DropDownButtonComponent
          items={this.sortMenuItems}
          select={this.onSortMenuSelect}
          cssClass='sort-dropdown-btn e-caret-hide'
        >
          <IoSwapVerticalOutline size={16} />
        </DropDownButtonComponent>

            <TextBoxComponent
              type={'text'}
              id='assignment_search'
              autocomplete='off'
              // input={this.searchNodes.bind(this)}
              showClearButton
              placeholder='Search'
              onChange={this.searchNodes.bind(this)}
            />
          </div>

          {this.state.sortField ? (
            <div className='active-sort-chip'>
              <span>{this.getSortLabel()}</span>
              <IoCloseOutline size={14} onClick={this.clearSort} />
            </div>
          ) : null}
        </div>
        <div className='assignments-treeview'>
          <div className='overflow-assign-treeview'>
            <div id='tree'>
              <TreeViewComponent
                id='treeAssign'
                fields={this.state.fields}
                drawNode={this.onDrawNode}
                ref={(treeview: TreeViewComponent) => {
                  this.treeObj = treeview;
                }}
                nodeClicked={this.nodeclicked.bind(this)}
                showCheckBox={this.isChecked}
                nodeChecked={this.nodeChecked}
                allowDragAndDrop={false}
                dragArea={
                  document.getElementById('SplitterInner') as HTMLElement
                }
                nodeTemplate={this.TreeAssignRenderTemplate}
              />
              <ContextMenuComponent
                id='contentmenutree'
                target='#tree'
                items={this.menuItems}
                select={this.menuclick.bind(this)}
                ref={(contextmenu) => {
                  this.menuObj = contextmenu;
                }}
              />
              <div className='control-pane-dialog'>
                <div
                  id='targetElement'
                  className='col-lg-12 defaultDialog dialog-target'
                >
                  <div>
                    {this.state.hideDialog ? (
                      <GenerateCapacity
                        assignments={this.state.selectedAssignments}
                        hideDialog={this.state.hideDialog}
                        isNoteMode={this.state.isNoteMode}
                        setHideDialogCapacity={(val) =>
                          this.setState({ hideDialog: val })
                        }
                      />
                    ) : null}
                  </div>
                  {this.state.tradeTeamSetVisible ? (
                    <TeamAndTradeSetter
                      affected={this.setTradeTeamAffected}
                      assignment_list={
                        this.props.storeAssign.length > 0
                          ? this.props.storeAssign
                          : [this.assignmentId]
                      }
                      hideDialogOrder={this.state.tradeTeamSetVisible}
                      setHideDialogSetter={this.setTeamTradeDialog.bind(this)}
                    />
                  ) : null}
                </div>
              </div>
              <div className='control-pane-dialogAdd'>
                <div
                  id='targetElementAddAssign'
                  className='col-lg-12 defaultDialogAddAssign dialog-target'
                >
                  {this.state.hideDialogAssignAdd ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignAdd}
                      width={'400px'}
                      height={'auto'}
                      header='Tradesperson'
                      buttons={[
                        {
                          click: () => {
                            this.addAssignElement();
                          },
                          buttonModel: {
                            content: 'Save',
                            isPrimary: true,
                            disabled: this.state.disabledAssignModal,
                          },
                        },
                        {
                          click: () => {
                            this.setState({ hideDialogAssignAdd: false });
                          },
                          buttonModel: {
                            content: 'Cancel',
                          },
                        },
                      ]}
                      open={this.dialogOpenAssignCrud.bind(this)}
                      close={this.dialogCloseAssignCrud.bind(this)}
                    >
                      <div className='row mb-3'>
                        <div className='col-md-3'>First Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter  Name'
                            value={this.addAssignName}
                            onChange={(e: any) => {
                              this.addAssignName = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Last Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Last Name'
                            value={this.addAssignLastname}
                            onChange={(e: any) => {
                              this.addAssignLastname = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Person ID:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Person ID'
                            value={this.assignPersonID}
                            onChange={(e: any) => {
                              this.assignPersonID = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Team:</div>
                        <div className='col-md-9'>
                          <DropDownListComponent
                            dataSource={this.state.teamData}
                            fields={{ value: 'team_id', text: 'team_code' }}
                            placeholder='Select a Team'
                            value={0}
                            onChange={(e: any) => {
                              return this.setState({
                                dropdownTeamSelectionForEdit: e.value,
                                teamId: e.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Trade:</div>
                        <div className='col-md-9'>
                          <DropDownListComponent
                            dataSource={this.state.tradeData}
                            fields={{ text: 'trade_code', value: 'trade_id' }}
                            placeholder='Select a Trade'
                            value={0}
                            onChange={(e: any) => {
                              return this.setState({
                                dropdownTradeSelectionForEdit: e.value,
                                tradeId: e.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Image</div>
                        <div className='col-md-9'>
                          <UploaderComponent
                            multiple={false}
                            allowedExtensions='.jpg,.png'
                            directoryUpload={false}
                          />
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}

                  {this.state.hideDialogAssignEdit ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignEdit}
                      width={'400px'}
                      height={'auto'}
                      header='Edit Tradesperson'
                      buttons={[
                        {
                          click: () => {
                            this.editAssignElement();
                          },
                          buttonModel: {
                            content: 'Save',
                            isPrimary: true,
                            disabled: this.state.disabledAssignModal,
                          },
                        },
                        {
                          click: () => {
                            this.setState({ hideDialogAssignEdit: false });
                          },
                          buttonModel: {
                            content: 'Cancel',
                          },
                        },
                      ]}
                      open={() => {
                        this.setState({ hideDialogAssignEdit: true });
                      }}
                      close={() => {
                        this.setState({ hideDialogAssignEdit: false });
                      }}
                    >
                      <div className='row mb-3'>
                        <div className='col-md-3'>First Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter  Name'
                            value={this.editAssignName}
                            onChange={(e: any) => {
                              this.editAssignName = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Last Name:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Last Name'
                            value={this.editAssignLastname}
                            onChange={(e: any) => {
                              this.editAssignLastname = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Person ID:</div>
                        <div className='col-md-9'>
                          <TextBoxComponent
                            placeholder='Enter Person ID'
                            value={this.assignPersonID}
                            onChange={(e: any) => {
                              this.assignPersonID = e.value;
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Team:</div>
                        <div className='col-md-9'>
                          <DropDownListComponent
                            dataSource={this.state.teamData}
                            fields={{ value: 'team_id', text: 'team_code' }}
                            placeholder='Select a Team'
                            value={this.state.teamId}
                            onChange={(e: any) => {
                              return this.setState({
                                dropdownTeamSelectionForEdit: e.value,
                                teamId: e.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Trade:</div>
                        <div className='col-md-9'>
                          <DropDownListComponent
                            dataSource={this.state.tradeData}
                            fields={{ text: 'trade_code', value: 'trade_id' }}
                            placeholder='Select a Trade'
                            value={this.state.tradeId}
                            onChange={(e: any) => {
                              return this.setState({
                                dropdownTradeSelectionForEdit: e.value,
                                tradeId: e.value,
                              });
                            }}
                          />
                        </div>
                      </div>
                      <div className='row mb-3'>
                        <div className='col-md-3'>Image</div>
                        <div className='col-md-9'>
                          <UploaderComponent
                            multiple={false}
                            allowedExtensions='.jpg,.png'
                            directoryUpload={false}
                          />
                        </div>
                      </div>
                    </DialogComponent>
                  ) : null}

                  {this.state.hideDialogAssignDelete ? (
                    <DialogComponent
                      isModal={true}
                      id='defaultDialogAddAssign'
                      showCloseIcon={true}
                      animationSettings={this.animationSettings}
                      visible={this.state.hideDialogAssignDelete}
                      width={'400px'}
                      height={'auto'}
                      header='Delete Tradesperson'
                      buttons={this.buttonsAssignmentsDelete}
                      open={() => {
                        this.setState({ hideDialogAssignDelete: true });
                      }}
                      close={() => {
                        this.setState({ hideDialogAssignDelete: false });
                      }}
                    >
                      <p>Are you sure?</p>
                    </DialogComponent>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  largeMode: state.search.largeMode,
  storeTeam: state.search.storeTeam,
  storeTrades: state.search.storeTrades,
  storeAssign: state.search.storeAssign,
  defaultTrades: state.search.defaultTrades,
  defaultTeams: state.search.defaultTeams,
  defaultAssignments: state.search.defaultAssignments,
  refreshAssignmentComponent: state.search.refreshAssignmentComponent,
});

const mapDispatchToProps = (dispatch: any) => ({
  setTrades: (data: any) => dispatch(setTrades(data)),

  setRefreshAssignmentComponent: (data: boolean) =>
    dispatch(setRefreshAssignmentComponent(data)),
  setStoreAssign: (data: any) => dispatch(setStoreAssign(data)),
  setAssignments: (data: any) => dispatch(setAssignments(data)),
  setRefreshTeamComponent: (data: boolean) =>
    dispatch(setRefreshTeamComponent(data)),
  setRefreshTradeComponent: (data: boolean) =>
    dispatch(setRefreshTradeComponent(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Assignments);
